module.exports = __webpack_public_path__ + "static/media/welcome-image.36fb6cfb.png";